// extracted by mini-css-extract-plugin
export var mainSection = "bloghead-module--mainSection--SCKVG";
export var contentWrap = "bloghead-module--contentWrap--2G4gZ";
export var content = "bloghead-module--content--resef";
export var button4 = "bloghead-module--button4--dojQ8";
export var btn4 = "bloghead-module--btn4--+MBHE";
export var back = "bloghead-module--back--clAub";